import { USER_KIND_CHOICES } from '../constants/appConstants';

const userChecker = (kind) => {
  const privilegedRoles = ['Admin', 'Manager', 'Assistant Manager', 'Bar'];
  return privilegedRoles.includes(USER_KIND_CHOICES[kind]);
};

export default userChecker;
